<template>
	<button type="button" v-on="$listeners">
		<svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 21 24">
			<g fill="#4A4A4A" fill-rule="nonzero">
				<path d="M21 5.168c0-1.221-.98-2.215-2.183-2.215h-5.302V1.951C13.515.875 12.652 0 11.592 0H9.408c-1.06 0-1.923.875-1.923 1.951v1.002H2.183C.98 2.953 0 3.947 0 5.168c0 .898.53 1.672 1.288 2.02v14.108c0 1.49 1.195 2.704 2.665 2.704h13.094c1.47 0 2.665-1.213 2.665-2.704v-6.83a.524.524 0 0 0-.52-.527.524.524 0 0 0-.52.528v6.829c0 .91-.729 1.65-1.625 1.65H3.953c-.896 0-1.625-.74-1.625-1.65V7.386H4.68l5.593 5.674a.514.514 0 0 0 .734 0l2.655-2.69.444.45a.514.514 0 0 0 .735 0l3.385-3.434h.446v3.061c0 .291.233.527.52.527.287 0 .52-.236.52-.527v-3.26A2.219 2.219 0 0 0 21 5.168zM8.525 1.951c0-.494.396-.896.883-.896h2.184c.487 0 .883.402.883.896v1.002h-3.95V1.951zm2.115 9.99L6.15 7.386h4.572l2.205 2.237-2.287 2.318zm3.834-2.24l-2.282-2.315h4.564L14.474 9.7zm4.343-3.373H2.183c-.63 0-1.143-.52-1.143-1.16 0-.64.513-1.16 1.143-1.16h16.634c.63 0 1.143.52 1.143 1.16 0 .64-.513 1.16-1.143 1.16z"/>
				<path d="M19.146 12.146a.504.504 0 0 0 0 .708.504.504 0 0 0 .708 0 .503.503 0 0 0 0-.708.504.504 0 0 0-.708 0zM15 11.446v9.108c0 .246.224.446.5.446s.5-.2.5-.446v-9.108c0-.246-.224-.446-.5-.446s-.5.2-.5.446zM10 16.421v4.158c0 .233.224.421.5.421s.5-.188.5-.421v-4.158c0-.233-.224-.421-.5-.421s-.5.189-.5.421zM5 10.442v10.116c0 .244.224.442.5.442s.5-.198.5-.442V10.442c0-.244-.224-.442-.5-.442s-.5.198-.5.442zM10.854 14.147a.503.503 0 0 0-.708 0 .504.504 0 0 0 0 .707.503.503 0 0 0 .708 0 .504.504 0 0 0 0-.707z"/>
			</g>
		</svg>
	</button>
</template>
<script>
export default {
	name: 'comments-component',
	inheritAttrs: false,
	props: {
		width: {
			type: Number,
			default: 21,
		},
		height: {
			type: Number,
			default: 24,
		},
	},
};
</script>




// WEBPACK FOOTER //
// src/components/shared/icons/trash-component.vue